
import {AMBROSIA_URL} from '../../helpers/auth-header'
import Axios from 'axios'


export default{

    /**
     * Submit comments
     *
     * @param commit
     * @param dispatch
     * @param e
     * @returns {Promise<void>}
     */
    SubmitComments({dispatch},e){
        let postData = {
            name:e.target.name.value,
            orderNumber:  e.target.orderNumber == undefined ? " " : e.target.orderNumber.value ,
            commentType:e.target.commentType.value,
            commentClass:e.target.commentClass.value,
            contactEmail:e.target.description.value,
            emailContent:e.target.emailContent.value,
            response:e.target.response.value
        }
        
        Axios.post(AMBROSIA_URL + '/web/submit-comments',postData)
        .then(response => {
            dispatch('ShowToast', { 'icon':'success', 'title':'Comentarios enviados'})
        })
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title':'Ocurrio un error al enviar comentarios'})
        })
    },

    /**
     * Submit Gofarma in your company
     *
     * @param commit
     * @param dispatch
     * @param e
     * @returns {Promise<void>}
     */
    SubmitBusinessComments({commit, dispatch},e){
        let postData = {
            request:e.target.request.value,
            companyName:e.target.companyName.value,
            companyType:e.target.companyType.value,
            contactPage:e.target.contactPage.value,
            contactName:e.target.contactName.value,
            contactEmail:e.target.description.value,
            preferredContact:e.target.preferredContact.value,
            emailContent:e.target.emailContent.value,
            contactTime:' ',
            phone:e.target.phone.value,
            other:' ',
        }
        Axios.post(AMBROSIA_URL + '/web/submit-business-comments',postData)
        .then(response => {
            dispatch('ShowToast', { 'icon':'success', 'title':'Comentarios enviados'})
        })
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title':'Ocurrio un error al enviar comentarios'})
        })
    }
}